import React from 'react'
import Navigation from '../../components/Navigations/Navigation';
import Footer from '../../components/Footer/Footer';
import Gallery from '../../components/Gallery/Gallery';
import Slider from '../../components/GallarySlider/GallarySlider';

const GalleryPage = () => {
  return (
    <div>
      {/* <div><Navigation /></div> */}
     <div> 
    <Slider />
     </div>
      <div> <Gallery /> </div>
      {/* <div> <Footer /></div> */}
    </div>
  )
}

export default GalleryPage
